module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_7042.a17c8c29.png";